import React, { useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import toast from "react-hot-toast";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

export default function Extract({
  setBulkPartService,
  bulkPartservice,
  getVehicleServicePartDetails,
  workOrderDetail,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const handlePdf = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = async function () {
      const typedArray = new Uint8Array(this.result);

      const pdf = await pdfjsLib.getDocument(typedArray).promise;

      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);

        const content = await page.getTextContent();

        const text = content.items.map((item) => item.str).join(" ");

        fullText += text + "\n";
      }

      // ✅ Extract only Part Detail section
      const startIndex = fullText.indexOf("Part Detail");
      const endIndex = fullText.indexOf("Labour Detail");

      let partDetails = "";

      if (startIndex !== -1 && endIndex !== -1) {
        partDetails = fullText
          .substring(startIndex + "Part Detail".length, endIndex)
          .trim();
      }

      // ✅ Regex
      const regex =
        /(\d+)\s+(.+?)\s+([A-Z0-9,]+)\s+([\d,]+\.\d+)\s+([\d.]+)\s+([\d,]+\.\d+)\s+([\d,]+\.\d+)/g;

      const convertedData = [];

      let match;

      while ((match = regex.exec(partDetails)) !== null) {
        convertedData.push({
          partName: match[2]?.trim() || null,
          partNumber: match[3] || null,
          actionOnPart: "Replacement",
          quantity: match[5] || null,
          unitPrice: match[4]?.replace(/,/g, "") || null,
          laborCost: match[6]?.replace(/,/g, "") || null,
          totalCost: match[7]?.replace(/,/g, "") || null,
          warrantyExpiryDate: null,
          attachments: [],
        });
      }

      // ✅ Set state
      setBulkPartService(convertedData);

      console.log(convertedData);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleBulkUpload = async () => {
    if (!bulkPartservice?.length) {
      toast.error("No parts available");
      return;
    }

    try {
      // ✅ Loop all parts and save one by one
      for (const item of bulkPartservice) {
        let payload = {
          partName: item?.partName,
          partNumber: item?.partNumber,
          actionOnPart: item?.actionOnPart,
          quantity: item?.quantity,
          unitPrice: item?.unitPrice,
          warrantyExpiryDate: item?.warrantyExpiryDate,
          attachments: JSON.stringify(item?.attachments || []),
          laborCost: item?.laborCost,
          logId: workOrderDetail?.id,
        };

        const res = await fetch(`${apiUrl}/api/vehicleserviceparts`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data?.statusCode !== "0100") {
          throw new Error("Failed to save part");
        }
      }

      // ✅ Success after all APIs completed
      toast.success("All Vehicle Service Parts Added Successfully 🎉");

      // ✅ Clear state
      setBulkPartService([
        {
          partName: "",
          partNumber: "",
          actionOnPart: "",
          quantity: "",
          unitPrice: "",
          laborCost: "",
          totalCost: "",
          warrantyExpiryDate: "",
          attachments: [],
        },
      ]);

      // ✅ Call GET API only once after loop completes
      await getVehicleServicePartDetails(workOrderDetail?.id);
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong while saving parts");
    }
  };

  return (
    <div className="grid grid-cols-12">
      <div className="w-full max-w-md mx-auto col-span-3">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Upload PDF File
        </label>

        <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-6 hover:border-blue-500 transition-all duration-300 bg-gray-50">
          <input
            type="file"
            accept="application/pdf"
            onChange={handlePdf}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />

          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-100 mb-3">
              📄
            </div>

            <h3 className="text-base font-semibold text-gray-800">
              Choose a PDF File
            </h3>

            <p className="text-sm text-gray-500 mt-1">
              Drag & drop your PDF here or click to browse
            </p>

            <button
              type="button"
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition"
            >
              Browse File
            </button>
          </div>
        </div>
      </div>

      <div className="p-6 col-span-9">
        <button onClick={() => {handleBulkUpload()}}>Bulk Add</button>
        <div className="overflow-x-auto rounded-2xl shadow-lg border border-gray-200 h-60 overflow-y-scroll">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="px-4 py-3 text-left">Part Name</th>
                <th className="px-4 py-3 text-left">Part Number</th>
                <th className="px-4 py-3 text-left">Action</th>
                <th className="px-4 py-3 text-left">Qty</th>
                <th className="px-4 py-3 text-left">Unit Price</th>
                <th className="px-4 py-3 text-left">Labor Cost</th>
                <th className="px-4 py-3 text-left">Total Cost</th>
                <th className="px-4 py-3 text-left">Warranty Expiry</th>
                <th className="px-4 py-3 text-left">Attachments</th>
              </tr>
            </thead>

            <tbody>
              {bulkPartservice?.length > 0 ? (
                bulkPartservice.map((item, index) => (
                  <tr
                    key={index}
                    className="border-t hover:bg-gray-50 transition"
                  >
                    <td className="px-4 py-3">{item?.partName || "-"}</td>
                    <td className="px-4 py-3">{item?.partNumber || "-"}</td>
                    <td className="px-4 py-3">{item?.actionOnPart || "-"}</td>
                    <td className="px-4 py-3">{item?.quantity || "-"}</td>
                    <td className="px-4 py-3">{item?.unitPrice || "-"}</td>
                    <td className="px-4 py-3">{item?.laborCost || "-"}</td>
                    <td className="px-4 py-3">{item?.totalCost || "-"}</td>
                    <td className="px-4 py-3">
                      {item?.warrantyExpiryDate || "-"}
                    </td>
                    <td className="px-4 py-3">
                      {item?.attachments?.length > 0 ? (
                        <ul className="list-disc list-inside">
                          {item.attachments.map((file, i) => (
                            <li key={i}>{file}</li>
                          ))}
                        </ul>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-6 text-gray-500">
                    No Part Service Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
